import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Amendment, eAmendmentType, instantValidationThrottle, Order, OrderManagerService, OrderUIConfiguration, ValidationProblem } from 'reg-hub-common';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-amendment-details',
    templateUrl: './amendment-details.component.html',
    styleUrls: ['./amendment-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AmendmentDetailsComponent implements OnInit, OnDestroy {
  @Input() uiConfiguration!: OrderUIConfiguration;
  @Input() errors$!: Observable<ValidationProblem[] | undefined>;
  @Output() amendmentDetailsFormChanged = new EventEmitter<Amendment>();

  private order!: Order;
  amendmentDetails!: FormGroup;

  change = eAmendmentType.change;
  correction = eAmendmentType.correction;

  reasonTextError$ = new BehaviorSubject<string | null | undefined>(null);

  private onDestroy$ = new Subject<void>();

  constructor(
    private orderManager: OrderManagerService,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.orderManager.currentOrder.subscribe(order => this.order = order);

    this.amendmentDetails = this.formBuilder.group({ });
    this.amendmentDetails.valueChanges
      .pipe(
        takeUntil(this.onDestroy$),
        instantValidationThrottle())
      .subscribe(value => this.amendmentDetailsFormChanged.emit(value));

    if(this.uiConfiguration.amendmentConfiguration?.showCorrectionOrChange) {
      this.amendmentDetails.addControl('amendmentTypeID', this.formBuilder.control(this.order.amendment?.amendmentTypeID ?? eAmendmentType.change));
    }

    if(this.errors$) {
      this.errors$
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(errors => this.pushErrors(errors));
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  public updateAmendment(order: Order) {
  }

  private pushErrors(errors: ValidationProblem[] | undefined) {
    if(!errors) {
      return;
    }

  }
}
